$(function () {
  /**
   * ページ内の各要素の指定
   */

  // formタグのID
  var formID = "#form";

  // formの実行先のiframeID
  var hiddenIframeID = "#hidden_iframe";

  // サンクスページのURL（Shopify用）
  var thanksPageURL = "/pages/contact-thanks";

  // ポップアップ内の送信ボタンのID
  var popupSubmitBtnID = "#popup-submit-btn";

  // 確認画面の実際の送信ボタン
  var submitBtnID = ".btn-link";

  // フォームの必須項目
  var cheackElm = [
    "name",
    "namekana",
    "email",
    "contactType",
    "additionalDetails",
    "privacyPolicyAgreement",
  ];

  // お問い合わせ種別
  var contactTypeElm = [
    "商品について",
    "ご注文について",
    "配送について",
    "返品・返金について",
    "メール配信について",
    "その他お問い合わせ",
  ];
  createSelectOptions("contactType", "entry.10666010", contactTypeElm);

  // プライバシーポリシー
  var privacyPolicyAgreementElm = ["プライバシーポリシーに同意する"];
  createCheckboxElements(
    "privacyPolicyAgreement",
    "entry.1268752413",
    privacyPolicyAgreementElm
  );

  // 送信フラグ
  var submitted = false;

  function validateForm() {
    cheackElm.forEach(function (elementId) {
      var value = $("#" + elementId).val();
      var errorElement = $("#" + elementId + "_error");

      errorElement.text("");
      errorElement.removeClass("error_active");

      switch (elementId) {
        case "name":
          if (!value.trim()) {
            errorElement.text("この質問は必須です。").addClass("error_active");
          } else if (value.length > 100) {
            errorElement
              .text("氏名は100文字以下で入力してください。")
              .addClass("error_active");
          }
          break;
        case "namekana":
          if (!value.trim()) {
            errorElement.text("この質問は必須です。").addClass("error_active");
          } else if (value.length > 100) {
            errorElement
              .text("氏名は100文字以下で入力してください。")
              .addClass("error_active");
          }
          break;
        case "email":
          if (!value.trim()) {
            errorElement.text("この質問は必須です。").addClass("error_active");
          } else if (!value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            errorElement
              .text("有効なメールアドレスを入力してください。")
              .addClass("error_active");
          }
          break;
        case "phoneNumber":
          if (value.trim() && !value.match(/^\d{10,11}$/)) {
            errorElement
              .text("電話番号は10桁または11桁の数字で入力してください。")
              .addClass("error_active");
          }
          break;
        case "contactType":
          var contactTypeValue = cheackSelectEmpty("contactType");
          if (!contactTypeValue) {
            errorElement
              .text("お問い合わせ種別を選択してください。")
              .addClass("error_active");
          } else if (!isSelectValue("contactType", contactTypeElm)) {
            errorElement
              .text("無効な値が選択されました。")
              .addClass("error_active");
          }
          break;
        case "additionalDetails":
          if (!value.trim()) {
            errorElement.text("この質問は必須です。").addClass("error_active");
          } else if (value.length > 5000) {
            errorElement
              .text("5000文字以下で入力してください。")
              .addClass("error_active");
          }
          break;
        case "privacyPolicyAgreement":
          var checkedCheckboxes = getCheckedCheckboxes(
            "privacyPolicyAgreement"
          );
          var checkedCheckboxesIs = isCheckedCheckboxes(
            "privacyPolicyAgreement",
            privacyPolicyAgreementElm
          );
          if (checkedCheckboxes.length === 0) {
            errorElement
              .text("プライバシーポリシーに同意する必要があります。")
              .addClass("error_active");
          } else if (!checkedCheckboxesIs) {
            errorElement
              .text("無効な値が選択されました。")
              .addClass("error_active");
          }
          break;
      }
    });

    var errorMessages = cheackElm
      .map(function (elementId) {
        return $("#" + elementId + "_error").text();
      })
      .filter(function (message) {
        return message.trim() !== "";
      });

    return errorMessages.length === 0;
  }

  var hiddenIframe = $(hiddenIframeID);
  hiddenIframe.on("load", function () {
    if (submitted) {
      window.location = thanksPageURL;
    }
  });

  // チェックボックス生成関数
  function createCheckboxElements(id, name, elements) {
    var containerDiv = $("#" + id);
    for (var i = 0; i < elements.length; i++) {
      var input = $("<input>").attr({
        type: "checkbox",
        id: id + "_" + (i + 1),
        name: name,
        value: elements[i],
      });
      containerDiv.append(input);

      var label = $("<label>").attr("for", id + "_" + (i + 1));
      var span = $("<span>").text(elements[i]);
      label.append(span);
      containerDiv.append(label);
      containerDiv.append("<br>");
    }
  }

  function getCheckedCheckboxes(id) {
    var checkboxes = $("#" + id + ' input[type="checkbox"]');
    return checkboxes.filter(":checked");
  }

  function isCheckedCheckboxes(id, elements) {
    var checkedValues = getCheckedCheckboxes(id)
      .map(function () {
        return $(this).val();
      })
      .get();
    return checkedValues.every(function (value) {
      return elements.includes(value);
    });
  }

  // セレクトボックスの選択肢を生成する関数
  function createSelectOptions(id, name, elements) {
    var selectElement = $("#" + id).attr("name", name);
    var defaultOption = $("<option>").attr({
      value: "",
    });
    selectElement.append(defaultOption);

    for (var i = 0; i < elements.length; i++) {
      var option = $("<option>").attr({
        value: elements[i],
      });
      selectElement.append(option);
    }

    var createSelectBox = $("<div>").addClass("easy-select-box");
    var displayerDiv = $("<div>")
      .addClass("esb-displayer")
      .text("選択してください");
    var dropdownDiv = $("<div>").addClass("esb-dropdown");

    var defaultOptionHtml = $("<div>")
      .addClass("esb-item")
      .text("選択してください");
    dropdownDiv.append(defaultOptionHtml);

    for (var i = 0; i < elements.length; i++) {
      var option = $("<div>").addClass("esb-item").text(elements[i]);
      dropdownDiv.append(option);
    }

    createSelectBox.append(displayerDiv);
    createSelectBox.append(dropdownDiv);

    selectElement.after(createSelectBox);

    createSelectBox.on("click", function (event) {
      event.stopPropagation();
      $(".easy-select-box").not($(this)).removeClass("focused");
      $(this).toggleClass("focused");
      $(".esb-dropdown")
        .not($(this).find(".esb-dropdown"))
        .removeClass("active");
      $(this).find(".esb-dropdown").toggleClass("active");
    });

    createSelectBox.find(".esb-item").on("click", function () {
      var selectedText = $(this).text();
      createSelectBox.find(".esb-displayer").text(selectedText);

      selectElement.find("option").prop("selected", false);
      selectElement
        .find('option[value="' + selectedText + '"]')
        .prop("selected", true);
    });
  }

  // Easy Select Box以外の要素クリックで閉じる
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".easy-select-box").length) {
      $(".easy-select-box").removeClass("focused");
      $(".esb-dropdown").removeClass("active");
    }
  });

  // セレクトボックスのバリデーション
  function cheackSelectEmpty(id) {
    var selectElement = $("#" + id);
    return selectElement.val();
  }
  function isSelectValue(id, elements) {
    var selectElement = $("#" + id);
    var selectedValue = selectElement.val();
    return elements.includes(selectedValue);
  }

  // ポップアップの確認ボタン
  $(popupSubmitBtnID).on("click", function (e) {
    e.preventDefault();
    if (submitted) return;
    if (validateForm()) {
      displayConfirmationPopup();
      $("#confirmation-popup").fadeIn();
      $(".header").addClass("header-none");
    }
  });

  // 閉じるボタン
  $(".popup-close").on("click", function () {
    $("#confirmation-popup").fadeOut();
    $(".header").removeClass("header-none");

    // ▼ ポップアップ閉じたら送信ロック解除
    $(submitBtnID)
      .data("clicked", false)
      .removeClass("disabled")
      .css({ pointerEvents: "auto", opacity: "1" });
  });

  function displayConfirmationPopup() {
    var name = $("#name").val();
    var nameKana = $("#namekana").val();
    var phoneNumber = $("#phoneNumber").val();
    var email = $("#email").val();
    var contactType = $("#contactType").val();
    var additionalDetails = $("#additionalDetails").val();

    $(".line-break.name").text(name);
    $(".line-break.nameKana").text(nameKana);
    $(".line-break.phoneNumber").text(phoneNumber);
    $(".line-break.email").text(email);
    $(".line-break.contactType").text(contactType);
    $(".line-break.additionalDetails").text(additionalDetails);
  }

  // ▼ ポップアップ送信（多重送信防止対応）
  $(submitBtnID).on("click", function (e) {
    e.preventDefault();

    // ▼ 多重送信防止（送信済みなら即ブロック）
    if (submitted) return;
    if ($(this).data("clicked")) return;
    $(this)
      .data("clicked", true)
      .addClass("disabled")
      .css({ pointerEvents: "none", opacity: "0.6" });

    // ハニーポット判定（ボットが入力していたらブロック）
    if ($("#gf-hp-field").val()) {
      window.location = thanksPageURL;
      return;
    }

    if (validateForm()) {
      submitted = true;

      // ポップアップを閉じて送信中オーバーレイを表示
      $("#confirmation-popup").fadeOut();
      $(".header").removeClass("header-none");
      var overlay = $("<div>")
        .attr("id", "sending-overlay")
        .css({
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
        });
      var message = $("<p>")
        .text("送信中...")
        .css({
          color: "#fff",
          fontSize: "20px",
          fontWeight: "bold",
        });
      overlay.append(message);
      $("body").append(overlay);

      sessionStorage.setItem("contactFormSubmitted", "true");
      $(formID).submit();
    } else {
      alert("操作に誤りがあります。");

      // ▼ NG時は解除
      $(this)
        .data("clicked", false)
        .removeClass("disabled")
        .css({ pointerEvents: "auto", opacity: "1" });
    }
  });

  // ポップアップ外クリックで閉じる
  $("#confirmation-popup").on("click", function (e) {
    if (!$(e.target).closest(".popup-content").length) {
      $(this).fadeOut();
      $(".header").removeClass("header-none");

      // ▼ ロック解除
      $(submitBtnID)
        .data("clicked", false)
        .removeClass("disabled")
        .css({ pointerEvents: "auto", opacity: "1" });
    }
  });
});
